import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconChannelAdobeExperienceManager = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          d="M4.25 0H19.75C22.1 0 24 1.94872 24 4.35897V19.641C24 22.0513 22.1 24 19.75 24H4.25C1.9 24 0 22.0513 0 19.641V4.35897C0 1.94872 1.9 0 4.25 0Z"
          fill="#FA0F00"
        />
        <path
          d="M18.6603 18.0513H15.8103C15.5603 18.0513 15.3303 17.9077 15.2303 17.6616L12.1403 10.2359C12.1203 10.1641 12.0403 10.1231 11.9703 10.1436C11.9303 10.1539 11.8903 10.1949 11.8803 10.2359L9.95027 14.9436C9.91027 15.0257 9.95027 15.1282 10.0403 15.159C10.0603 15.1693 10.0803 15.1693 10.1003 15.1693H12.2203C12.3503 15.1693 12.4703 15.2513 12.5203 15.3744L13.4503 17.4975C13.5303 17.6923 13.4403 17.9282 13.2503 18.0103C13.2003 18.0308 13.1503 18.0411 13.1003 18.0411H5.38027C5.19027 18.0411 5.03027 17.877 5.03027 17.6821C5.03027 17.6308 5.04027 17.5898 5.06027 17.5385L9.97027 5.54875C10.0703 5.29234 10.3203 5.11798 10.5903 5.12824H13.4203C13.6903 5.12824 13.9403 5.29234 14.0403 5.54875L18.9803 17.5385C19.0603 17.7231 18.9703 17.9385 18.8003 18.0103C18.7503 18.0308 18.7103 18.0411 18.6603 18.0513Z"
          fill="white"
        />
      </SvgIcon>
    );
  })
);
